(function () {
  const wrapper = document.querySelector(
    "[data-collection-description-wrapper]",
  );
  if (!wrapper) return;

  const description = wrapper.querySelector("[data-collection-description]");
  const button = wrapper.querySelector("[data-collection-read-more]");
  if (!description || !button) return;

  function checkClamp() {
    const isClamped = description.scrollHeight > description.clientHeight;

    if (isClamped) {
      button.classList.remove("hidden");
      button.classList.add("flex");
    } else {
      button.classList.add("hidden");
      button.classList.remove("flex");
    }
  }

  button.addEventListener("click", function () {
    const isExpanded = this.getAttribute("aria-expanded") === "true";
    const label = this.querySelector("[data-read-more-label]");

    if (isExpanded) {
      description.classList.add("line-clamp-3");
      this.setAttribute("aria-expanded", "false");
      if (label) {
        label.textContent = this.getAttribute("data-label-more");
      }
    } else {
      description.classList.remove("line-clamp-3");
      this.setAttribute("aria-expanded", "true");
      if (label) {
        label.textContent = this.getAttribute("data-label-less");
      }
    }
  });

  requestAnimationFrame(checkClamp);
  window.addEventListener("resize", checkClamp);
})();
